// extracted by mini-css-extract-plugin
module.exports = {"s876rwi":"s876rwi","aalvasc":"aalvasc"};